import { useCallback, useEffect, useMemo, useState } from "react";
import { throwGenericToasterError, toasterError, toasterSuccess } from "../../utils/methods";
import RollTrafficService from "../../services/rollTraffic.service";

export type rollServiceType = {
  loading: boolean;
  rollService: (id: number) => void;
};

function useRollService(portId: number | undefined, isMounted: boolean, refetch: () => void): rollServiceType {
  const [loading, setLoading] = useState<rollServiceType["loading"]>(false);
  const rollService = useCallback(
    (otherNrId: number) => {
      if (!portId || !otherNrId) return;
      setLoading(true);

      RollTrafficService.rollTrafficNetworkResource({ nrIdOne: portId, nrIdTwo: otherNrId })
        .then(() => {
          if (!isMounted) return;
          setLoading(false);
          refetch();
          toasterSuccess("Traffic Rolled Successfully");
        })
        .catch((err) => {
          setLoading(false);
          throwGenericToasterError(err);
        });
    },
    [portId, isMounted, refetch]
  );
  const returnProps = useMemo(() => {
    return {
      loading,
      rollService,
    };
  }, [loading, rollService]);
  return returnProps;
}

export default useRollService;
